import axios from "axios";

const STATUS_CACHE_TTL_MS = 60_000;
const statusCache = new Map();
const statusRequests = new Map();

const getCacheKey = (apiBase, storeId) => `${apiBase}:${storeId}`;

export const fetchStoreSettingsStatus = ({
  apiBase,
  storeId,
  forceRefresh = false,
}) => {
  if (!apiBase || !storeId) return Promise.resolve(null);

  const cacheKey = getCacheKey(apiBase, storeId);
  const cached = statusCache.get(cacheKey);
  if (
    !forceRefresh &&
    cached &&
    Date.now() - cached.cachedAt < STATUS_CACHE_TTL_MS
  ) {
    return Promise.resolve(cached.data);
  }

  if (statusRequests.has(cacheKey)) {
    return statusRequests.get(cacheKey);
  }

  const request = axios
    .get(`${apiBase}/v1/api/stores/${storeId}/settings`, {
      params: { view: "status" },
      timeout: 8000,
    })
    .then(({ data }) => {
      statusCache.set(cacheKey, {
        cachedAt: Date.now(),
        data,
      });
      return data;
    })
    .finally(() => {
      if (statusRequests.get(cacheKey) === request) {
        statusRequests.delete(cacheKey);
      }
    });

  statusRequests.set(cacheKey, request);
  return request;
};
